<template>
  <div>
    <Form ref="editModel" :model="editModel" :rules="ruleValidate" :label-width="100">
      <FormItem label="设备SN码" prop="clientSN">
        <Input v-model="editModel.clientSN" placeholder="设备SN码唯一" :disabled="true"></Input>
      </FormItem>
      <FormItem label="设备名称" prop="clientName">
        <Input v-model="editModel.clientName"></Input>
      </FormItem>
      <FormItem label="设备类型" prop="clientType">
        <Input v-model="editModel.clientType"></Input>
      </FormItem>
      <FormItem label="产品类型" prop="projectId">
        <Select v-model="editModel.projectId" @on-change="projectChange" :label-in-value="true">
          <Option
            v-for="(item, index) in clientSelect"
            :value="item.dictionaryID"
            :key="index"
          >{{ item.dictionaryValue }}</Option>
        </Select>
      </FormItem>

      <FormItem label="所属主设备" prop="clientID">
        <Select v-model="editModel.clientID">
          <Option
            v-for="(item, index) in clientList"
            :value="item.clientID"
            :key="index"
          >{{ item.clientName }}</Option>
        </Select>
      </FormItem>
      <!-- <FormItem label="所属机构" prop="organName">
        <Button type="primary" @click="treeModel=true">选择机构</Button>
        <span class="ml-5">{{editModel.organName}}</span>
      </FormItem> -->

      <FormItem label="描述信息">
        <Input
          v-model="editModel.clientDescription"
          type="textarea"
          :autosize="{minRows: 2,maxRows: 5}"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')">确 定</Button>
    </div>

    <!-- <Modal v-model="treeModel" title="选择机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal> -->
  </div>
</template>
<script>
import organTree from "../../basedata/organ/organTree.vue";
export default {
  props: ["currentData"],
  components: { organTree },
  data: function () {
    return {
      clientList: [],
      clientSelect: [],
      treeModel: false,
      organParentName: "",
      editModel: {
        clientDetailID: "",
        clientID: "",
        clientSN: "",
        clientName: "",
        clientType: "",
        clientDescription: "",
        organID: "",
        organName: "",
        projectId: "",
        projectName: "",
      },
      ruleValidate: {
        clientSN: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        organName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        projectId: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientID: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.editModel = this.currentData;
    this.$common.getDictionary("产品").then((data) => {
      this.clientSelect = data;
    });
    this.getclientList();
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("clientDetail/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    getclientList() {
      this.$api.get("client/getListAll").then((rsp) => {
        if (rsp != false) {
          this.clientList = rsp.data;
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
    selectTreeData: function (data) {
      this.editModel.organID = data[0].organID;
      this.editModel.organName = data[0].title;
    },
      projectChange(data) {
      this.editModel.projectName = data.label;
    },
  },
};
</script>
<style scoped>
</style>